import { TutorialDefinition } from "./types";

// Webpack-only API provided by CRA. Auto-registers every .ts file in tours/.
// To add a new tutorial: drop a new file in tours/ exporting a TutorialDefinition
// as the default export. No edits to this file required.
const ctx = (require as any).context("./tours", false, /\.ts$/);

export const ALL_TUTORIALS: TutorialDefinition[] = ctx
  .keys()
  .map((key: string) => {
    const mod = ctx(key);
    return (mod && (mod.default as TutorialDefinition)) || null;
  })
  .filter((t: TutorialDefinition | null): t is TutorialDefinition => !!t)
  // Newest first so the What's New list feels fresh.
  .sort(
    (a: TutorialDefinition, b: TutorialDefinition) =>
      Date.parse(b.releasedAt) - Date.parse(a.releasedAt),
  );

export const getTutorialById = (id: string): TutorialDefinition | undefined =>
  ALL_TUTORIALS.find((t) => t.id === id);
